<template>
  <div class="portfolio-access-denied-container">
    <div class="portfolio-access-denied-card">
      <p class="portfolio-access-denied-title">SIN ACCESO</p>
      <p class="portfolio-access-denied-text">
        El acceso basico a la web no incluye la funcionalidad de carteras.
        Para acceder, debe completar el curso avanzado y contratar un plan.
      </p>
      <div class="portfolio-access-denied-actions">
        <a
          class="portfolio-access-denied-link"
          href="https://online.eurekers.com/curso-avanzado-eurekers/"
          target="_blank"
          rel="noreferrer"
        >
          Curso Avanzado
        </a>
        <a class="portfolio-access-denied-link primary" href="/app/store">Contratar plan</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PortfolioAccessDenied',
};
</script>

<style scoped>
.portfolio-access-denied-container {
  min-height: calc(100vh - 140px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.portfolio-access-denied-card {
  max-width: 720px;
  width: 100%;
  border: 1px solid #dcdcdc;
  border-radius: 16px;
  padding: 36px 28px;
  background: #ffffff;
  text-align: center;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.06);
}

.portfolio-access-denied-title {
  margin: 0 0 12px 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 1px;
}

.portfolio-access-denied-text {
  margin: 0 0 24px 0;
  font-size: 16px;
  line-height: 1.5;
  color: #444444;
}

.portfolio-access-denied-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.portfolio-access-denied-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 18px;
  border-radius: 999px;
  border: 1px solid #2c2c2c;
  color: #2c2c2c;
  text-decoration: none;
  font-weight: 600;
  transition: transform 120ms ease, box-shadow 120ms ease;
}

.portfolio-access-denied-link:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
}

.portfolio-access-denied-link.primary {
  background: #2c2c2c;
  color: #ffffff;
}
</style>
